"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _userProfile = require("user-profile");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _noty = require("noty");

var _commentForm = babelHelpers.interopRequireDefault(require("./comment-form"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _class, _descriptor, _descriptor2, _descriptor3, _temp;

var DiscussionRootNode = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(DiscussionRootNode, _Component);

  function DiscussionRootNode() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, DiscussionRootNode);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(DiscussionRootNode)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "discussionRoot", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "commentPosted", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "trackData", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      submitting: false,
      userProfile: null
    };
    return _this;
  }

  babelHelpers.createClass(DiscussionRootNode, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      (0, _userProfile.getUserProfile)().then(function (profile) {
        _this2.setState({
          userProfile: profile
        });
      });
      $(document).on('profileUpdated', this.profileUpdated);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      $(document).off('profileUpdated', this.profileUpdated);
    }
  }, {
    key: "profileUpdated",
    value: function profileUpdated(event) {
      this.setState({
        userProfile: event.profile
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_commentForm.default, {
        submitComment: this.submitComment,
        userProfile: this.state.userProfile,
        submitting: this.state.submitting
      });
    }
  }, {
    key: "doPostComment",
    value: function doPostComment(comment) {
      return (0, _fetch.default)("data/discussion/post", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          child_type: 'comment',
          parent: this.discussionRoot.id,
          comment: comment,
          trackData: this.trackData
        })
      }).then(function (result) {
        if (result.ok) {
          return result.status == 204 ? true : result.json();
        }

        return result.json().then(function (value) {
          throw value;
        });
      });
    }
  }, {
    key: "submitComment",
    value: function submitComment(comment) {
      var _this3 = this;

      return new _promisePolyfill.default(function (resolve, reject) {
        _this3.setState({
          submitting: true
        }, function () {
          _this3.doPostComment(comment).then(function (result) {
            _this3.setState({
              submitting: false
            }, function () {
              (0, _noty.showNotificationText)('Your comment has been posted.');

              _this3.commentPosted();

              resolve(true);
            });
          }).catch(function (error) {
            _this3.setState({
              submitting: false
            }, function () {
              reject(error);
            });
          });
        });
      });
    }
  }]);
  return DiscussionRootNode;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "discussionRoot", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "commentPosted", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "trackData", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "profileUpdated", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "profileUpdated"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "submitComment", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "submitComment"), _class.prototype)), _class);
exports.default = DiscussionRootNode;